export default {
  GET_ALL: 'getAllAttributeMappings',
  SAVE_ATTRIBUTE_MAPPING: 'saveAttributeMapping',
  DELETE_ATTRIBUTE_MAPPING: 'deleteAttributeMapping',
}